import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import React from "react";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";
import { mapToDDL } from "../../common/mapper";
import M from "moment";
import SimpleCheckBox from "../../../modules/SimpleCheckBox";
import { parseStringBBN } from "./util";

export const formGroupMasterBBN = {
  idRequest: { value: "" },
  tanggalRequest: { value: null },
  module: { value: null },
  nomorDokumenReferensi: { value: null },
  userPemohon: { value: null },
  approvalStatus: { value: null },
};

export const initialData = {
  search: {
    startRequestDate: M().format("DD-MM-YYYY"),
    endRequestDate: M().format("DD-MM-YYYY"),
  },
  filter: {
    kodeCabang: null,
    idPelanggaran: null,
    module: null,
    nomorDokumenReferensi: null,
    userPemohon: null,
    authorizedBy: null,
    status: null,
    startRequestDate: null,
    endRequestDate: null,
    startApprovalDate: null,
    endApprovalDate: null,
    deskripsiPelanggaran: null,
    periode: { value: "TANGGAL_REQUEST", label: "TANGGAL REQUEST" },
  },
  detail: {
    kodeVariant: null,
    namaVariant: null,
    bbnPrice: null,
    differenceIncomeBbn: null,
  },
};

export const tableColumns = {
  mainPage: (
    menuAccess,
    dataTable,
    handleModifyingModalVisibility,
    handleDelete
  ) => {
    return [
      {
        name: "",
        label: "No",
        options: {
          customBodyRender: (_, tableMeta) => {
            const { page, rowsPerPage } = tableMeta.tableState;
            const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

            return <>{rowNumber}</>;
          },
          sort: false,
        },
      },
      {
        name: "idRequest",
        label: "ID Request",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "tanggalRequest",
        label: "Tanggal Request",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "module",
        label: "Modul/Menu",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "nomorDokumenReferensi",
        label: "Nomor Dokumen",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "userPemohon",
        label: "User Pemohon",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "approvalStatus",
        label: "Status ",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "tanggalKeputusan",
        label: "Tanggal Keputusan",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "",
        label: "Aksi",
        options: {
          customBodyRender: (_, tableMeta) => {
            return (
              <FlexView vAlignContent="center">
                {menuAccess && menuAccess.updateAccess && (
                  <SimpleButton
                    category="action_button"
                    style={{ marginRight: 15, backgroundColor: "transparent" }}
                    icon={
                      <i
                        style={{ fontSize: 20, color: "red" }}
                        className="fa fa-lg fa-eye"
                      />
                    }
                    onClick={() =>
                      handleModifyingModalVisibility(tableMeta.rowIndex, "view")
                    }
                  />
                )}
                {menuAccess && menuAccess.updateAccess && (
                  <SimpleButton
                    category="action_button"
                    style={{ marginRight: 15, backgroundColor: "transparent" }}
                    icon={
                      <i
                        style={{ fontSize: 20, color: "red" }}
                        className="fa fa-lg fa-paper-plane"
                      />
                    }
                    onClick={() =>
                      handleModifyingModalVisibility(tableMeta.rowIndex, "edit")
                    }
                  />
                )}
              </FlexView>
            );
          },
          sort: false,
        },
      },
    ];
  },
  detailPage: (menuAccess, user, handleChecked, controls, type) => {
    return [
      {
        name: "",
        label: "No",
        options: {
          customBodyRender: (_, tableMeta) => {
            const { page, rowsPerPage } = tableMeta.tableState;
            const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

            return <>{rowNumber}</>;
          },
          sort: false,
        },
      },
      {
        name: "idPelanggaran",
        label: "ID Pelanggaran",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "detailPelanggaran",
        label: "Deskripsi Pelanggaran",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      // {
      //   name: "keterangan",
      //   label: "Keterangan",
      //   options: {
      //     customBodyRender: (val) => <p>{val}</p>,
      //     sort: false,
      //   },
      // },
      {
        name: "keterangan",
        label: "Keterangan",
        options: {
          setCellProps: () => ({
            style: { width: "300px", minWidth: "300px" },
          }),
          customBodyRender: (val) => {
            const modul = controls.module.value;
            let result = val

            if (modul === "RECEIVING_UNIT" || modul === "RECEIVING_KSU") {
              return (
                <p>
                  {result?.split(",").map((item, index) => (
                    <span key={index}>
                      {item}
                      <br />
                    </span>
                  ))}
                </p>
              );
            }

            if(modul === 'Penyerahan BBN'){
              result = parseStringBBN(val)?.displayView
            }

            return <p style={{ whiteSpace: "pre-line" }}>{result}</p>;
          },
          sort: false,
        },
      },
      {
        name: "line",
        label: "Line",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "levelMinimal",
        label: "Level Minimal",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "approvedBy",
        label: "Authorized By",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "approvalStatus",
        label: "Status",
        options: {
          customBodyRender: (val) => <p>{val}</p>,
          sort: false,
        },
      },
      {
        name: "checkboxStatus",
        label: "Approve",
        options: {
          customBodyRender: (val, tableMeta) => {
            const rowIndex = tableMeta.rowIndex;
            const isChecked = val === "APPROVED";

            const disabledByStatus =
              tableMeta.rowData[7] == "APPROVED" ||
              tableMeta.rowData[7] == "REJECT";

            let isCheckLine = false;
            if (tableMeta.rowData[4] == "Adm") {
              isCheckLine = user.administrationLine >= tableMeta.rowData[5];
            } else if (tableMeta.rowData[4] == "Mkt") {
              isCheckLine = user.marketingLine >= tableMeta.rowData[5];
            } else {
              isCheckLine = user.ahassLine >= tableMeta.rowData[5];
            }

            return (
              <FlexView
                vAlignContent="center"
                style={{
                  gap: 10,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SimpleCheckBox
                  id={`checkbox_approve_${rowIndex}`}
                  checked={isChecked}
                  disabled={!isCheckLine || disabledByStatus || type == 'view'}
                  onChange={() => handleChecked(rowIndex, "APPROVED")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
              </FlexView>
            );
          },
          sort: false,
        },
      },
      {
        name: "checkboxStatus",
        label: "Reject",
        options: {
          customBodyRender: (val, tableMeta) => {
            const rowIndex = tableMeta.rowIndex;
            const isChecked = val === "REJECT";

            const disabledByStatus =
              tableMeta.rowData[7] == "APPROVED" ||
              tableMeta.rowData[7] == "REJECT";

            let isCheckLine = false;
            if (tableMeta.rowData[4] == "Adm") {
              isCheckLine = user.administrationLine >= tableMeta.rowData[5];
            } else if (tableMeta.rowData[4] == "Mkt") {
              isCheckLine = user.marketingLine >= tableMeta.rowData[5];
            } else {
              isCheckLine = user.ahassLine >= tableMeta.rowData[5];
            }

            return (
              <FlexView
                vAlignContent="center"
                style={{
                  gap: 10,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SimpleCheckBox
                  id={`checkbox_reject_${rowIndex}`}
                  checked={isChecked}
                  disabled={!isCheckLine || disabledByStatus || type == 'view'}
                  onChange={() => handleChecked(rowIndex, "REJECT")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                />
              </FlexView>
            );
          },
          sort: false,
        },
      },
    ];
  },
};

export const SAMPLE_DATA = [
  {
    idRequest: "AREQ/NYAH/2025/02/0001",
    tanggalRequest: "",
    module: "Faktur Jual",
    documentReference: "FJ/NYAH/2025/07/000017",
    userPemohon: "Tompi Tapilulu",
    statusApproval: "INCOMPLETE",
    decitionDate: "",
  },
];

export const SAMPLE_DETAIL = [
  {
    idPelanggaran: "APPRV0010",
    detailPelanggaran: "Overdiskon",
    keterangan: "",
    line: "MKT",
    levelMinimal: 4,
    approvedBy: "Sri Mulyono",
    approvalStatus: "",
    checkboxStatus: "INCOMPLETE",
  },
];
